function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 33"
}, props), React.createElement("path", {
  d: "M13 16.5c.894 0 1.66-.323 2.296-.97a3.201 3.201 0 00.954-2.33c0-.907-.318-1.685-.954-2.332C14.66 10.223 13.894 9.9 13 9.9c-.894 0-1.659.323-2.294.968A3.204 3.204 0 009.75 13.2c0 .908.319 1.684.956 2.33.635.647 1.4.97 2.294.97zM13 33c-4.36-3.767-7.617-7.267-9.77-10.499C1.077 19.271 0 16.28 0 13.53c0-4.125 1.307-7.411 3.921-9.859C6.534 1.224 9.561 0 13 0c3.44 0 6.466 1.224 9.079 3.671C24.693 6.12 26 9.405 26 13.53c0 2.75-1.076 5.74-3.229 8.971C20.617 25.733 17.361 29.233 13 33z",
  fill: "#6B6565"
})));